import React from "react";
import PropTypes from "prop-types";
import FileInputComponent from "react-file-input-previews-base64";

export default class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    this.saveAndUpload = this.saveAndUpload.bind(this);

    this.state = {
      file: ""
    };
  }

  getFiles(file) {
    this.setState({ file: file });
  }

  saveAndUpload() {
    this.props.uploadImage(this.state.file);
  }

  render() {
    return (
      <div>
        {!this.state.file && <p className="select-image">Click Select Image button below to upload an image from your computer.</p>}
        {this.state.file && (
          <button className="save-image" onClick={this.saveAndUpload}>
            Save
          </button>
        )}

        <FileInputComponent
          multiple={false}
          callbackFunction={fileArr => {
            this.getFiles(fileArr.base64);
          }}
          buttonComponent={<button className={`select-image ${this.state.file && "selected"}`}>Select Image</button>}
          accept="image/*"
          imageStyle={{
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            objectFit: "cover",
            position: "relative",
            top: "0",
            right: "15px"
          }}
          labelStyle={{
            display: "none"
          }}
          imageContainerStyle={{
            float: "left"
          }}
        />
      </div>
    );
  }
}

ImageUpload.prototypes = {
  uploadImage: PropTypes.func
};

ImageUpload.defaultProps = {
  uploadImage: () => null
};
